import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { Close } from "@mui/icons-material";
import Api from "lib/api/httpRequestHelper";
import { getUserId } from "utils/get-user-info";

export default function SolicitarAlteracaoDialog({ onClose, type, storeId }) {
  const [submitting, setSubmitting] = useState(false);
  const [justificativa, setJustificativa] = useState("");

  const userId = getUserId();
  const resolvedType =
    typeof type === "object" && type?.requestType ? type.requestType : type;
  const prefilledDescription =
    typeof type === "object" && type?.prefilledDescription
      ? type.prefilledDescription
      : "";

  const typeMap = {
    ADDRESS: { typeRequest: "Estrutura", title: "Endereço" },
    REPRESENTANTE: { typeRequest: "REPRESENTANTE", title: "Representante" },
    CONTACT: { typeRequest: "CONTATOS", title: "Contato" },
    USERS: { typeRequest: "LOJISTA", title: "Usuários" },
  };

  const snackbar = useSnackbar();

  useEffect(() => {
    setJustificativa(prefilledDescription);
  }, [prefilledDescription, storeId]);

  const submit = async () => {
    setSubmitting(true);
    try {
      await Api.post(
        "create-request-struture",
        "commercialstructure",
        {
          idPessoaLoja: storeId,
          idMarca: 1,
          idCanal: 1,
          statusSolicitacao: "Pendente",
          tipoSolicitacao: typeMap[resolvedType].typeRequest,
          descricao: justificativa,
          idUsuarioSolicitacao: userId,
          notificado: true,
          observacoes: "",
        },
        true
      );
      snackbar.showMessage("Solicitação de alteração enviada com sucesso!", {
        severity: "success",
      });
      onClose();
    } catch (error) {
      snackbar.showMessage("Erro ao enviar solicitação de alteração!", {
        severity: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth={"md"} fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            Solicitar Alteração de {typeMap[resolvedType]?.title ?? "Contato"}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h4">O que você deseja alterar?</Typography>
        <Box position="relative">
          <OutlinedInput
            fullWidth
            multiline
            rows={4}
            value={justificativa}
            onChange={(e) => setJustificativa(e.target.value)}
            placeholder="Digite aqui o que voce deseja alterar"
            disabled={submitting}
            style={{ marginBottom: "1rem" }}
            inputProps={{ maxLength: 1000 }}
          />
          <Typography
            variant="caption"
            color="textPrimary"
            style={{
              position: "absolute",
              right: 0,
              bottom: 10,
              marginRight: "0.5rem",
              marginBottom: "0.5rem",
              fontSize: "0.75rem",
            }}
          >
            {justificativa.length}/1000
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={submitting || !justificativa}
          onClick={submit}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
